import { Fragment, useEffect, useState } from 'react';

import infoIcon from '../../assets/svgs/info_24px.svg';
import { Button } from '../buttons/Button';
import { CustomIcon } from './CustomIcon';
import { Switch } from './Switch';
import { TooltipComponent } from './Tooltip';

type ToggleCardProps = {
  title?: string;
  isOn: boolean;
  tooltip?: string;
  isLoading?: boolean;
  disabled?: boolean;
  description?: string;
  error?: boolean;
  children?: React.ReactNode;
  saveChildren?: React.ReactNode;
  handleSave?: () => void;
  onOffFunction?: () => void;
};

export const ToggleCard = ({
  title,
  isOn,
  tooltip,
  description,
  error = false,
  children,
  disabled,
  saveChildren,
  isLoading = false,
  handleSave,
  onOffFunction
}: ToggleCardProps) => {
  const [isChecked, setIsChecked] = useState(isOn);
  const [hasError, setHasError] = useState(error);

  const toggle = () => {
    setIsChecked((prev) => !prev);

    if (onOffFunction) {
      if (isChecked) onOffFunction();
    }
  };

  //para inserir quebras de linhas no título/descrição, utilizar {`\n`}, exemplo ConfiguracoesLeads.tsx
  const convertToJSX = (text: string) =>
    text?.split('\n').map((line, index) => (
      <Fragment key={index}>
        {line}
        <br />
      </Fragment>
    ));

  return (
    <div
      className={`${
        disabled ? 'tw-opacity-50 tw-pointer-events-none' : null
      }      
      tw-bg-[#FFFFFF] md:tw-w-[100%] tw-h-[16.25rem] tw-rounded-3xl tw-p-5 tw-flex tw-flex-col tw-justify-between `}
    >
      <div className="tw-flex tw-justify-between">
        <div className="tw-flex tw-items-center tw-gap-[10px]">
          <p className="tw-text-xl tw-font-bold tw-max-w-xs">
            {convertToJSX(title)}
          </p>
          {tooltip ? (
            <TooltipComponent tooltip={tooltip}>
              <CustomIcon src={infoIcon} width={20} height={20} />
            </TooltipComponent>
          ) : null}
        </div>

        <Switch handleSwitch={toggle} isChecked={isChecked} />
      </div>

      {description ? <p>{convertToJSX(description)}</p> : null}

      <div
        className={`${
          !isChecked ? 'tw-pointer-events-none tw-opacity-40' : null
        } `}
      >
        {children}
      </div>

      <div
        className={`tw-bg-[#F4F4F4] tw-h-[5.625rem] tw-rounded-3xl tw-flex tw-items-center tw-px-5 ${
          saveChildren ? 'tw-justify-between' : 'tw-justify-end'
        }`}
      >
        <div
          className={`${
            !isChecked ? 'tw-pointer-events-none tw-opacity-40' : null
          } `}
        >
          {saveChildren}
        </div>
        <Button
          onClick={handleSave}
          disabled={!isChecked || hasError}
          isLoading={isLoading}
        >
          Salvar
        </Button>
      </div>
    </div>
  );
};
